export enum TokenizationTypeUserEvents {
    ClickTokenizationTypeBadge = "Tokenization Type - Click Tokenization Type Badge",
}
